var map = {
	"./bh-ico.svg": 795,
	"./bonus-ico.svg": 796,
	"./deposit-ico.svg": 797,
	"./edit-icon.svg": 798,
	"./fb-ico.svg": 799,
	"./instant-rebate-ico.svg": 800,
	"./mall-ico.svg": 801,
	"./msg-ico.svg": 802,
	"./pi-ico.svg": 803,
	"./rf-ico.svg": 804,
	"./rh-ico.svg": 805,
	"./th-ico.svg": 806,
	"./vip-ico.svg": 807,
	"./withdrawal-ico.svg": 808,
	"./wl-ico.svg": 809
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2089;